import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import moment from 'moment';
import { useIntl } from 'react-intl';
import { SingleDatePicker } from 'react-dates';

const ExpirationDateDropdown = ({ expirationDate, onChange }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [datePickerFocused, setDatePickerFocused] = useState(false);
  const intl = useIntl();

  const getDateRanges = () => ([
    {
      id: '1-day',
      label: intl.formatMessage({ defaultMessage: 'one day' }),
      days: 1,
    },
    {
      id: '7-days',
      label: intl.formatMessage({ defaultMessage: 'one week' }),
      days: 7,
    },
    {
      id: '30-days',
      label: intl.formatMessage({ defaultMessage: 'one month' }),
      days: 30,
    },
    {
      id: '365-days',
      label: intl.formatMessage({ defaultMessage: 'one year' }),
      days: 365,
    },
  ]);

  const getDateTitle = () => {
    if (expirationDate !== null) {
      return expirationDate.format('MM/DD/YYYY');
    }
    return intl.formatMessage({ defaultMessage: 'never' });
  };

  const handleDate = (offset) => {
    if (offset === null) {
      onChange(null);
    } else {
      const date = moment().utc().add(offset, 'days');
      onChange(date);
    }
  };

  return (
    <div>
      <ButtonDropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
        <DropdownToggle color="link">
          {getDateTitle()}
          <i className="far fa-calendar" />
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem header>
            {intl.formatMessage({ defaultMessage: 'Set access to expire in' })}
          </DropdownItem>
          {expirationDate !== null && (
          <DropdownItem
            onClick={(e) => { e.preventDefault(); handleDate(null); }}
          >
            {intl.formatMessage({ defaultMessage: 'never' })}
          </DropdownItem>
          )}
          {getDateRanges(intl).map(dr => (
            <DropdownItem
              key={dr.id}
              onClick={(e) => {
                e.preventDefault();
                handleDate(dr.days);
              }}
            >
              {dr.label}
            </DropdownItem>
          ))}
          <DropdownItem divider />
          <DropdownItem onClick={() => { setDatePickerFocused(true); }}>
            {intl.formatMessage({ defaultMessage: 'custom date' })}
          </DropdownItem>
        </DropdownMenu>
      </ButtonDropdown>
      <SingleDatePicker
        id="expiration-date"
        date={expirationDate}
        onDateChange={(date) => { onChange(date); }}
        focused={datePickerFocused}
        onFocusChange={({ focused }) => setDatePickerFocused(focused)}
        numberOfMonths={1}
        withPortal={true}
        hideKeyboardShortcutsPanel={true}
        noBorder={true}
      />
    </div>
  );
};

ExpirationDateDropdown.propTypes = {
  expirationDate: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

ExpirationDateDropdown.defaultProps = {
  expirationDate: null,
};

export default ExpirationDateDropdown;
